import styled from '../references';

export const ScrollContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  overflow-y: auto;
`;

export const ScrollContainerCentered = styled(ScrollContainer)`
  justify-content: center;
`;

export const ScrollContainerRow = styled(ScrollContainer)`
  flex-direction: row;
`;
